import { SeoViewModel } from "../core/seo";
import { Configuration } from "../core/configuration";

import { Breadcrumbs } from "../cms/breadcrumbs";

export class Product {
    Id: number;
    IdGruppo: number;
    Name: string;
    Thumbnail: string;
    ShortDescription: string;
    Type: string;
    LongDescription: string;
    PhotoGallery: PhotoGalleryViewModel[];
    Attachments:AtachmentViewModel[];
    ProductCorrelati:Product[]
    Price: string;
    SeoUrl: string;
    RouterLink: any[];
    TemplateUrl: string;
    TemplateHtml: string;
    EstimateRequest: boolean;
    TimeDiscounts: boolean;
    TypeResultView: string;
    SeoInformation: SeoViewModel;
    PriceData: any;
    Active: boolean;
    IsWizard: boolean;
    BreadcrumbsInfo: Breadcrumbs[];
    ManageAttachment: string;
    CanvasInfo: any;
    listaRegole: Regola[];
    HeaderData:any;
    FooterData:any;
    AltMiniatura: string;
    TitleMiniatura: string;
    AltTop: string;
    TitleTop: string;
    AltFinal: string;
    TitleFinal: string;
    isProductPrivateActiveAndShow: boolean;
    IsPromo: boolean;
}

export interface Regola {
    Id: number;
    Nome_Regola: string;
    Tipo: string;
    Categoria_1: string;
    Sezione_1: string;
    Id_Elemento_1: number;
    Categoria_2: string;
    Sezione_2: string;
    Id_Elemento_2: number;
    IdRegoleCategoria: number;
    Id_Elemento_Sottochiave_1: number;
    Id_Elemento_Sottochiave_2: number;
    Tipo_Regola: string;
    Flag_Copertina_1?: boolean;
    Flag_Copertina_2?: boolean;
    Macro_Categoria_1: string;
    Macro_Categoria_2: string;
    Attivo?: boolean;
    nomeCategoria: string;
    nomeElemento1: string;
    nomeElemento2: string;
    stato: boolean;
    connectionString: string;
    descrizione: string;
}

export class PhotoGalleryViewModel {
    PhotoUrl: string;
    Alt: string;
    Title: string;
}
class AtachmentViewModel {
    Name: string;
    Url: string;
}
export class Category  {
    Id: number;
    Name: string;
    LongDescription: string;
    Image: string;
    Thumbnail: string;
    SliderImages: SliderViewModel[];
    SubCategories: Category[];
    SubProducts: Product[];
    ProductCorrelati: Product[];
    ShortDescription: string;
    SeoUrl: string;
    Children: Category[];
    RouterLink: any[];
    TemplateUrl: string;
    TemplateHtml: string;
    TypeGruppo: number;
    IdWizardMaster: number;
    MacroCategoryIdWizardMaster: number;
    IdProdottoMaster: number;
    WizardResultVisualizationType: string;
    WizardTemporalPricing:boolean;
    WizardQuotingRequest:boolean;
    SeoInformation: SeoViewModel;
    MacroCategory: string;
    Active: boolean;
    Configuration: Configuration;
    PriceData: any;
    TipoVisualizzazione: string;
    BreadcrumbsInfo: Breadcrumbs[];
    ProductAttachments:any[];
    ManageAttachmentWizard: string;
    headerData: any;
    footerData: any;
    PhotoGallery: any[];
    AltMiniatura: string;
    TitleMiniatura: string;
    AltTop: string;
    TitleTop: string;
    AltFinal: string;
    TitleFinal: string;
    IsNew: boolean;
}
export class SliderViewModel {
    SliderUrl: string;
}
export class MegaMenu {
    public Id: number;
    public ParentId: string;
    public Level: number;
    public Name: string;
    public Target: string;
    public Thumbnail: string;
    public IsNew: string;
    public SeoUrl: string;
    Children: Array<MegaMenu>;
    ShortDescription: string;
}




// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/models/inventory/inventory.ts